import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type RootConfigKey = 'dashboard' | 'settings' | 'mobile';

export const rootConfig: Record<RootConfigKey, MenuConfigItem> = {
    dashboard: {
        name: 'Dashboard',
        title: 'Dashboard',
        link: 'dashboard',
    },
    settings: {
        name: 'Settings',
        title: 'Settings',
        link: 'settings',
    },
    mobile: {
        name: 'Mobile',
        title: 'Mobile',
        link: 'mobile',
    },
};
